import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const FilterSliders = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M12 5.75h7m-7 0a1.75 1.75 0 1 0-3.5 0m3.5 0a1.75 1.75 0 1 1-3.5 0M5 18h2.625m0 0a1.75 1.75 0 1 0 3.5 0m-3.5 0a1.75 1.75 0 1 1 3.5 0M5 5.75h3.5M11.125 18H19m-2.625-6.125H19m-2.625 0a1.75 1.75 0 1 0-3.5 0m3.5 0a1.75 1.75 0 1 1-3.5 0m-7.875 0h7.875"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(FilterSliders) as SvgIcon;
export { ForwardRef as ReactComponent };
